export const shitFlowData = [
  {
    id: 1,
    url: "1.pdf",
    imgSrc: "image1.png",
    title: "Feni Municipality",
  },
  {
    id: 2,
    url: "2.pdf",
    imgSrc: "image2.png",
    title: "Gopalganj Municipality",
  },
  {
    id: 3,
    url: "3.pdf",
    imgSrc: "image3.png",
    title: "Gazipur City Corporation",
  },
  {
    id: 4,
    url: "4.pdf",
    imgSrc: "image4.png",
    title: "Bhola Municipality",
  },
  {
    id: 5,
    url: "5.pdf",
    imgSrc: "image5.png",
    title: "Brahmanbaria Municipality",
  },
  {
    id: 6,
    url: "6.pdf",
    imgSrc: "image6.png",
    title: "Chandpur Municipality",
  },
  {
    id: 7,
    url: "7.pdf",
    imgSrc: "image7.png",
    title: "Sirajganj Municipality",
  },
  {
    id: 8,
    url: "8.pdf",
    imgSrc: "image8.png",
    title: "Magura Municipality",
  },
  {
    id: 9,
    url: "9.pdf",
    imgSrc: "image9.png",
    title: "Nilphamari Municipality",
  },
  {
    id: 10,
    url: "10.pdf",
    imgSrc: "image10.png",
    title: "Joypurhat Municipality",
  },
  {
    id: 11,
    url: "11.pdf",
    imgSrc: "image11.png",
    title: "Naogaon Municipality",
  },
  {
    id: 12,
    url: "12.pdf",  
    imgSrc: "image12.png",
    title: "Thakurgaon Municipality",
  },
  {
    id: 13,
    url: "13.pdf",
    imgSrc: "image13.png",
    title: "Meherpur Municipality",
  },
  {
    id: 14,
    url: "14.pdf",
    imgSrc: "image14.png",
    title: "Rajbari Municipality",
  },
  {
    id: 15,
    url: "15.pdf",
    imgSrc: "image15.png",
    title: "Noakhali Municipality",
  },
  {
    id: 16,
    url: "16.pdf",
    imgSrc: "image16.png",
    title: "Sylhet City Corporation",
  },
  {
    id: 17,
    url: "17.pdf",
    imgSrc: "image17.png",
    title: "Chuadanga Municipality",
  },
  {
    id: 18,
    url: "18.pdf",
    imgSrc: "image18.png",
    title: "Narayanganj City Corporation",
  },
  {
    id: 19,
    url: "19.pdf",
    imgSrc: "image19.png",
    title: "Chapai Nawabganj Municipality",
  },
  {
    id: 20,
    url: "20.pdf",
    imgSrc: "image20.png",
    title: "Gaibandha Municipality",
  },
  {
    id: 21,
    url: "21.pdf",
    imgSrc: "image21.png",
    title: "Bogra Municipality",
  },
  {
    id: 22,
    url: "22.pdf",
    imgSrc: "image22.png",
    title: "Lalmonirhat Municipality",
  },
  {
    id: 23,
    url: "23.pdf",
    imgSrc: "image23.png",
    title: "Cumilla City Corporation",
  },
  {
    id: 24,
    url: "24.pdf",
    imgSrc: "image24.png",
    title: "Lakshmipur Municipality",
  },
  {
    id: 25,
    url: "25.pdf",
    imgSrc: "image25.png",
    title: "Panchagarh Municipality",
  },
  {
    id: 26,
    url: "26.pdf",
    imgSrc: "image26.png",
    title: "Kishoreganj Municipality",
  },
  {
    id: 27,
    url: "27.pdf",
    imgSrc: "image27.png",
    title: "Dinajpur Municipality",
  },
  {
    id: 28,
    url: "28.pdf",
    imgSrc: "image28.png",
    title: "Natore Municipality",
  },
  {
    id: 29,
    url: "29.pdf",
    imgSrc: "image29.png",
    title: "Patuakhali Municipality",
  },
  {
    id: 30,
    url: "30.pdf",
    imgSrc: "image30.png",
    title: "Bagerhat Municipality",
  },
  {
    id: 31,
    url: "31.pdf",
    imgSrc: "image31.png",
    title: "Shariatpur Municipality",
  },
  {
    id: 32,
    url: "32.pdf",
    imgSrc: "image32.png",
    title: "Ghatail Municipality",
  },
  {
    id: 33,
    url: "33.pdf",
    imgSrc: "image33.png",
    title: "Narsingdi Municipality",
  },
  {
    id: 34,
    url: "34.pdf",
    imgSrc: "image34.png",
    title: "Mirzapur Municipality",
  },
  {
    id: 35,
    url: "35.pdf",
    imgSrc: "image35.png",
    title: "Bandarban Municipality",
  },
  {
    id: 36,
    url: "36.pdf",
    imgSrc: "image36.png",
    title: "Homna Municipality",
  },
  {
    id: 37,
    url: "37.pdf",
    imgSrc: "image37.png",
    title: "Tarabo Municipality",
  },
  {
    id: 38,
    url: "38.pdf",  
    imgSrc: "image38.png",
    title: "Ishwardi Municipality",
  },
  {
    id: 39,
    url: "39.pdf",
    imgSrc: "image39.png",
    title: "Rangamati Municipality",
  },
  {
    id: 40,
    url: "40.pdf",
    imgSrc: "image40.png",
    title: "Jamalpur Municipality",
  },
  {
    id: 41,
    url: "41.pdf",
    imgSrc: "image41.png",
    title: "Pabna Municipality",
  },
  {
    id: 42,
    url: "42.pdf",
    imgSrc: "image42.png",
    title: "Lama Municipality",
  },
  {
    id: 43,
    url: "43.pdf",
    imgSrc: "image43.png",
    title: "Betagi Municipality",
  },
  {
    id: 44,
    url: "44.pdf",  
    imgSrc: "image44.png",
    title: "Kalihati Municipality",
  },
  {
    id: 45,
    url: "45.pdf",
    imgSrc: "image45.png",
    title: "Sreepur Municipality",
  },
  {
    id: 46,
    url: "46.pdf",
    imgSrc: "image46.png",
    title: "Sonargaon Municipality",
  },
  {
    id: 47,
    url: "47.pdf",
    imgSrc: "image47.png",
    title: "Singair Municipality",
  },
  {
    id: 48,
    url: "48.pdf",
    imgSrc: "image48.png",
    title: "Paikgachha Municipality",
  },
  {
    id: 49,
    url: "49.pdf",
    imgSrc: "image49.png",
    title: "Galachipa Municipality",
  },
  {
    id: 50,
    url: "50.pdf",
    imgSrc: "image50.png",
    title: "Bauphal Municipality",
  },
  {
    id: 51,
    url: "51.pdf",
    imgSrc: "image51.png",
    title: "Kaliakair Municipality",
  },
  {
    id: 52,
    url: "52.pdf",
    imgSrc: "image52.png",
    title: "Jhenaidah Municipality",
  },
  {
    id: 53,
    url: "53.pdf",
    imgSrc: "image53.png",
    title: "Barishal City Corporation",
  },
  {
    id: 54,
    url: "54.pdf",
    imgSrc: "image54.png",
    title: "Barguna Municipality",
  },
];
